import { useMutation } from "@tanstack/react-query";
import { OpenGymReservationService } from "../../services/open-gym-reservation.service";

export const useOpenGymReservationMutations = () => {
  const { mutate: cancel } = useMutation<
    any,
    Error,
    { openGymReservationId: number; gymListingId: string }
  >({
    mutationFn: async ({ openGymReservationId, gymListingId }) =>
      OpenGymReservationService.cancel(openGymReservationId, gymListingId),
  });

  return {
    cancel,
  };
};
